import { BasketQuote } from '~/lib/types/basket-types';
import { QuoteFilterOptions, ServiceTypes, ToServiceTypeDefaultLabel } from '~/lib/quotes';
import { P2GButtonGroup, P2GButtonGroupItem, P2GGrid, P2GText } from '@parcel2go/core-ui';
import SortBy from './quote-filter-sort';
import { useTranslation } from 'react-i18next';
import { TranslationNamespaces } from '~/lib/constants';
import { useMemo } from 'react';
import { useTenant } from '@parcel2go/npm-p2g-app';
import { PublicSettings } from '~/lib/ui-serverless-settings';

export default function QuoteFilterMinimal({
  filter,
  onChange
}: {
  origin?: string;
  destination?: string;
  filter: QuoteFilterOptions;
  onChange: (filter: QuoteFilterOptions) => void;
  filteredQuotes: BasketQuote[];
  quotes: BasketQuote[];
}) {
  const { settings } = useTenant();
  const { t } = useTranslation([TranslationNamespaces.QUOTE]);

  const serviceOptionsEnabled = settings[PublicSettings.QUOTES.SERVICEOPTIONSENABLED] === 'true';
  const sortEnabled = settings[PublicSettings.QUOTES.SORTENABLED] === 'true';

  const listServiceTypes = useMemo(() => {
    return ServiceTypes.filter((x) => x === 'Collection' || x === 'Drop Off');
  }, []);

  if (!serviceOptionsEnabled && !sortEnabled) {
    return null;
  }

  return (
    <P2GGrid container direction="column" gap={2} dataTestId="quotes-filter-minimal">
      {serviceOptionsEnabled && (
        <>
          <P2GGrid item>
            <P2GGrid container alignItems="center" justifyContent="center">
              <P2GGrid item>
                <P2GText variant="h2">
                  {t('FILTER_SERVICE_TYPE_TITLE', { defaultValue: 'Choose a delivery service' })}
                </P2GText>
              </P2GGrid>
            </P2GGrid>
          </P2GGrid>
          <P2GGrid item>
            <P2GGrid container justifyContent="center">
              <P2GGrid item>
                <P2GButtonGroup>
                  {listServiceTypes.map((s) => (
                    <P2GButtonGroupItem
                      value={s}
                      selected={filter.serviceType || ''}
                      onClick={() => onChange({ ...filter, serviceType: s })}
                    >
                      {t(`FILTER_SERVICE_TYPE_OPTION_${s}`.toUpperCase(), {
                        defaultValue: ToServiceTypeDefaultLabel(s)
                      })}
                    </P2GButtonGroupItem>
                  ))}
                </P2GButtonGroup>
              </P2GGrid>
            </P2GGrid>
          </P2GGrid>
        </>
      )}
      {sortEnabled && (
        <P2GGrid item>
          <P2GGrid container justifyContent="flex-end">
            <P2GGrid item>
              <SortBy
                filter={filter}
                onChange={onChange}
                dataTestId="quotes-filter-sort-type"
                label={t('FILTER_SORT_TYPE_TITLE', { defaultValue: 'Sort By' })}
              />
            </P2GGrid>
          </P2GGrid>
        </P2GGrid>
      )}
    </P2GGrid>
  );
}
